import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import axios from "axios";
import { Button, Icon } from 'semantic-ui-react'

import { ReciboItem } from "./ReciboItem";
import "./RecibosGenerados.css";

const apiURL = process.env.REACT_APP_API_URL;

export default observer(function RecibosGenerados() {

    const url = apiURL +'/CCTRecibos/RecibosXEstudiantes'
    const [recibo, setRecibos] = useState([]);

    const listaRecibos = async () => {
        const responseRecibo = await axios(url);
        const { data } = responseRecibo;
        
        const recibos = data.map((recibo: { id: number; cuenta: string; nombreServicio: string; fechaEmision: any; monto: number; urlRecibo: { url: string; }; }) => {
            const formatter = new Intl.NumberFormat('en-US');
            let montoDelRecibo1 = formatter.format(recibo.monto)
            
            return {

                id: recibo.id,
                cuenta: recibo.cuenta,
                nombreServicio: recibo?.nombreServicio,
                fecha: recibo.fechaEmision,
                monto: parseFloat(montoDelRecibo1),
                url: recibo?.urlRecibo

            }
        })
        return recibos
        
    }

    useEffect(() => { 
        let isMounted = true;
        
        listaRecibos().then((recibos) => { //comprobando que el componente esta montado antes de cambiar estado
            if(isMounted){
                setRecibos(recibos);
            }
        })
        
        return () => {
            isMounted = false;
        }
    }, [])

    return (
        <>
            <h1 className="recibos-title">Recibos Generados</h1>
            <div className="intro2">En está sección podrás descargar los recibos 63A2, que corresponden a los pagos que realices con tu tarjeta de crédito o débito.
            </div>
            
            <div className="table-responsive">
                <table>
                    <thead>
                        <tr className='recibo-head-row'>
                            <th className='recibo-head-th '>
                                Número 63A2
                            </th>

                            <th className='recibo-head-th-small '>
                                Código del curso
                            </th>

                            <th className='recibo-head-th-big '>
                                Nombre del curso
                            </th>

                            <th className='recibo-head-th-small '>
                                Fecha
                            </th>

                            <th className='recibo-head-th-small '>
                                Monto
                            </th>

                            <th className='recibo-head-th-small '>
                                Descargar
                            </th>
                        </tr>
                    </thead >

                    <tbody>
                        {/*
                            recibo.map( (recibo: { id: number; cuenta: string; nombreServicio: string; fecha: any; monto: number;  url: any;}) => (
                                <ReciboItem { ...recibo } />
                            ))
                            */}
                            {recibo.map((recibo: { id: number; cuenta: string; nombreServicio: string; fecha: any; monto: number;  url: any;}) => {
                                const rFirma = process.env.REACT_APP_FIRMADO_URL;

                                const nf = new Intl.NumberFormat("en-IN");
                                const formatter = new Intl.NumberFormat('en-US');
                                const montoDelRecibo1 = formatter.format(recibo.monto)
                                const urlrecibo = rFirma+'/'+recibo.url;
                                
                                let valor;
                            
                                if((recibo.monto % 1) == 0){
                                    valor = montoDelRecibo1 + ".00"
                                }else{
                                    valor= montoDelRecibo1
                                }
                                return (
                                    <tr className='recibo-body-row' key={recibo.id}>
                            
                                        <td className='recibo-body-td'>
                                            {recibo.id}
                                        </td>
                            
                                        <td className='recibo-body-td-small'>
                                            {recibo.cuenta}
                                        </td>
                            
                                        <td className='recibo-body-td-big'>
                                            {recibo.nombreServicio}
                                        </td>
                            
                                        <td className='recibo-body-td-small'>
                                            {recibo.fecha}
                                        </td>
                            
                                        <td className='recibo-body-td-small'>
                                            Q. {valor}
                                        </td>
                            
                                        <td className='recibo-body-td-small'>
                                            <a href={urlrecibo} target="_blank"> <Button animated='vertical' color='blue'>
                                                    <Button.Content hidden>Descargar</Button.Content>
                                                    <Button.Content visible><Icon name='file pdf' /></Button.Content>
                                            </Button></a>
                                        </td>
                            
                                    </tr >
                                )
                            })}
                    </tbody>
                </table>
            </div>
        </>
    )

})
